import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../locales/messages';
import './RPAROIEstimator.scss';

export interface thanksProps {
  currentNumberOfHoursPerWeek: number;
  currentFullTimeEmployeeCost: number;
  errorRate: number;
  numberOfProcessToAutomate: number;
  roiValue: string;
}

const ThanksDetails = ({
  currentNumberOfHoursPerWeek,
  currentFullTimeEmployeeCost,
  errorRate,
  numberOfProcessToAutomate,
  roiValue,
}: thanksProps): ReactElement => {
  return (
    <div className="thanks__requirement thanks__pad4">
      <FormattedMessage
        {...messages.totalNumberOfBusinessProcessToAutomateTitle}
      />
      : <strong>{` ${numberOfProcessToAutomate}%`}</strong>
      <br />
      <FormattedMessage {...messages.numberOfHoursPerWeekTitle} />:
      <strong>{` ${currentNumberOfHoursPerWeek}`}</strong>
      <br />
      <FormattedMessage {...messages.fullTimeEmployeeCostTitle} />:
      <strong>{` ${currentFullTimeEmployeeCost}`}</strong>
      <br />
      <FormattedMessage {...messages.errorRateTitle} />:
      <strong>{` ${errorRate}`}</strong>
      <br />
      <FormattedMessage {...messages.estimatedRoi} />:
      <strong>{` ${roiValue}`}</strong>
      <br />
    </div>
  );
};

export default ThanksDetails;
